import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles/';
import { Button, ButtonType } from '@lean-body/components/atoms';
import { TwitterLogoIcon } from '@lean-body/components/atoms/icons/twitter_logo_icon';
export const TwitterEllipseButton = ({ text, onClick, classObject }) => {
    return (React.createElement(Button, { className: css(styles.button, classObject), buttonType: ButtonType.twitter, onClick: onClick, isRadius: true },
        React.createElement("div", { className: css(styles.buttonInner) },
            React.createElement(TwitterLogoIcon, { color: Colors.White, classObject: styles.twitterLogo }),
            React.createElement("div", { className: css(styles.label) }, text))));
};
const styles = StyleSheet.create({
    button: {
        textAlign: 'center',
        height: 48,
        [MediaBreakPointUp.XL]: {
            height: 60,
        },
    },
    buttonInner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'nowrap',
    },
    twitterLogo: {
        marginRight: 6,
    },
    label: {
        fontSize: 16,
        fontWeight: 'bold',
        [MediaBreakPointUp.XL]: {
            fontSize: 20,
        },
    },
});
